
import { firebase_Db} from '../../src/config/firebaseConfig';

const DBName = "user";


const getUsers = async () => {
    return await firebase_Db.collection(DBName).get();
}




export {getUsers};